import { ILoggedInUser } from 'es/app/business-logic/domain-models/User';
import HttpClient from 'es/core/net/http';

export async function fetchLoggedInUser(companyAlias?: string, facilityAlias?: string) {
    const response = await HttpClient.useInternalApi.withCredentials(companyAlias, facilityAlias).get('user');
    const { id, username, email, firstName, lastName, locale, userStatistics, passwordTokens } = response.data;
    return {
        id,
        username,
        email,
        firstName,
        lastName,
        locale,
        userStatistics,
        passwordTokens,
    } as ILoggedInUser;
}

export default fetchLoggedInUser;
